<template>
  <div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
        <kendo-datepicker
      :default-value="new Date()"
      :format="'dd/MMM/yyyy'"
      :week-number="true"
      class="w-50"
      :name="fieldName"
      :value="value"
      @input="$emit('input', $event.target.value)"
    ></kendo-datepicker>
   
      </div>
      </div>

  <!-- <div class="col-3 mb-3">
    <label>{{ labelText }}</label>
    <kendo-datepicker
      :default-value="new Date()"
      :format="'dd/MMM/yyyy'"
      :week-number="true"
      class="w-100"
      :name="fieldName"
      :value="value"
      @input="$emit('input', $event.target.value)"
    ></kendo-datepicker>
   
  </div> -->
</template>
<script>
// import { DatePicker } from "@progress/kendo-vue-dateinputs";

// Vue.component("datepicker", DatePicker);
export default {
  name: "Datetime",
  props: ["placeholder", "labelText", "fieldName", "value"],
};
</script>
